module.exports = __webpack_public_path__ + "img/otherInHouse1.7938faf5.jpg";